<template>
  <v-alert
    v-if="visible"
    color="#fff8e1"
    border="left"
    elevation="2"
    class="insurance-protection-date-notice mb-5"
  >
    <v-icon color="#f57f17" class="mr-2">mdi-information</v-icon>
    ค้นหาจากวันเริ่มคุ้มครอง ใช้ได้กับบิลที่ออกหลังจากวันที่ 16/09/2569
    เท่านั้น ขออภัยในความไม่สะดวก
  </v-alert>
</template>

<script>
const NOTICE_END_AT = new Date('2026-10-16T23:59:59+07:00').getTime();

export default {
  data: () => ({
    visible: Date.now() <= NOTICE_END_AT,
  }),
};
</script>

<style scoped>
.insurance-protection-date-notice {
  color: #e65100;
  font-weight: 500;
}
</style>
